import { render, staticRenderFns } from "./shield-tick.vue?vue&type=template&id=035c2670&"
import script from "./shield-tick.vue?vue&type=script&lang=js&"
export * from "./shield-tick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports